var map = {
	"./balsamiq.svg": "a9e4",
	"./bulma.svg": "80f6",
	"./ember.svg": "fc30",
	"./js.svg": "9c76",
	"./mongo.svg": "a873",
	"./node.svg": "ccdd",
	"./ruby.svg": "16cc",
	"./sass.svg": "cb3e",
	"./sketch.svg": "0a8a",
	"./sql.svg": "1665",
	"./tailwind.svg": "d19e",
	"./vue.svg": "0528"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfc3";